import { combineReducers } from '@reduxjs/toolkit'
import session from './sessionSlice'
import user from './userSlice'
import company from './companySlice'
import printers from './printerSlice'

const reducer = combineReducers({
    session,
    user,
    company,
    printers,
})

export default reducer
